import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from '@/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
  console.log(environment.production)
}

(window as any).PF = {
  config: {
    mode: 'bs4'
  }
};

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
